import * as React from 'react';
import { Button, createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { fontFamilies } from '../../theme/text';

interface Props {
  text: string;
  title: string;
  deactive?: boolean;
  styles?: any;
  handleClick: (event?) => void;
}
const materialTheme = createTheme({
  // @ts-ignore
  overrides: {
    MuiButton: {
      root: {
        padding: 0,
        textTransform: 'inherit',
        '&$disabled': {
          backgroundColor: '#dadada !important',
          color: '#4f4f4f !important'
        },
        fontWeight: 400,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        fontFamily: fontFamilies.heading
      },
      colorInherit: {
        color: '#ffffff',
        backgroundColor: '#00223c',
        '&:hover': {
          backgroundColor: '#0073b9'
        },
        '&:focus': {
          backgroundColor: '#00aafc',
          color: '#000000'
        }
      }
    },
    MuiButtonBase: {
      root: {
        width: '100%',
        height: '100%',
        fontWeight: 400,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        fontFamily: fontFamilies.heading
      }
    }
  }
});

const PrimaryButton = ({ text, title, deactive, styles: extraStyles, handleClick }: Props) => {
  return (
    <ThemeProvider theme={materialTheme}>
      <Button
        type="submit"
        title={title}
        onClick={event => {
          event.preventDefault();
          handleClick();
        }}
        variant="contained"
        color="inherit"
        disabled={deactive}
        style={extraStyles}
      >
        {text}
      </Button>
    </ThemeProvider>
  );
};

export default PrimaryButton;
